<template>
    <div class="sip-empty" :class="'sip-empty--' + size" role="status">
        <div class="sip-empty__well" aria-hidden="true">
            <admin-icon :name="icon" :size="iconPx"></admin-icon>
        </div>
        <h4 class="sip-empty__title">{{ title }}</h4>
        <p v-if="hintText" class="sip-empty__hint">{{ hintText }}</p>
        <div v-if="hasAction" class="sip-empty__action">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EmptyState',
        props: {
            title: {
                type: String,
                default: 'No Record Found',
            },
            description: {
                type: String,
                default: null,
            },
            icon: {
                type: String,
                default: 'inbox',
            },
            size: {
                type: String,
                default: 'md',
            },
        },
        computed: {
            iconPx() {
                return this.size === 'sm' ? 16 : 22;
            },
            hintText() {
                if (this.description === '') {
                    return '';
                }
                if (this.description) {
                    return this.description;
                }
                if (this.size === 'sm') {
                    return '';
                }
                return "There's nothing to show here yet.";
            },
            hasAction() {
                return this.slotHasNode(this.$slots.default);
            },
        },
        methods: {
            slotHasNode(nodes) {
                if (!nodes) {
                    return false;
                }
                if (typeof nodes === 'function') {
                    try {
                        nodes = nodes();
                    } catch (e) {
                        return true;
                    }
                }
                if (!Array.isArray(nodes) || !nodes.length) {
                    return false;
                }
                return nodes.some(function (vnode) {
                    return !!(vnode && (vnode.tag || (vnode.text && String(vnode.text).trim())));
                });
            },
        },
    };
</script>
